
<template>
    <li>
        <a
            class="button"
            :class="['pagination-link', { 'is-current': page.current_page === pageNumber }]"
            @click="goToPage(pageNumber)"
        >
            {{ pageNumber }}
        </a>
    </li>
</template>

<script>
export default {
    emits: ['updatePage'],
    
    props: [
        'page',
        'pageNumber',
        'context'
    ],

    methods: {
        goToPage(pageNumber) {
            this.$emit('updatePage', pageNumber);
        }
    }
};
</script>
